var modules_3734c084 = {"wrapper":"_1pjgz7e","wrapper--hidden":"_1c9otsi","overlay":"_q5el32","header":"_1bapwap"};
import "../../../assets/jCyqwPcj.css";

export { modules_3734c084 as default };
//# sourceMappingURL=fullscreen-wrapper.module.scss.js.map
